import { render, staticRenderFns } from "./SideList.vue?vue&type=template&id=3b87bc02&"
import script from "./SideList.vue?vue&type=script&lang=js&"
export * from "./SideList.vue?vue&type=script&lang=js&"
import style0 from "./SideList.vue?vue&type=style&index=0&id=3b87bc02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports